import { createStore, applyMiddleware } from "redux";
import { persistStore, persistReducer, createMigrate } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web and AsyncStorage for react-native
import rootReducer from "./reducers/reducers";
import thunk from "redux-thunk";
import migrations from "./migrations/migrations";

const persistConfig = {
  key: "root",
  storage,
  blacklist: ["createAccount", "config", "optanon"],
  version: 3,
  migrate: createMigrate(migrations, { debug: true }),
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(persistedReducer, applyMiddleware(thunk));
export const persistor = persistStore(store);
// persistor.purge();
